import { render, staticRenderFns } from "./MigrationSummaryItems.vue?vue&type=template&id=02f766e4"
import script from "./MigrationSummaryItems.vue?vue&type=script&lang=js"
export * from "./MigrationSummaryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports